export default {
  'runCode.mapping': 'Mapeo de respuesta',
  'runCode.addMapping': 'Agregar mapeo',
  'runCode.noMappings': 'Aún no hay mapeos de respuesta.',
  'runCode.form.responseProperty': 'Propiedad de respuesta',
};
